import { render, staticRenderFns } from "./PermissionModal.vue?vue&type=template&id=5cf845b4&scoped=true&"
import script from "./PermissionModal.vue?vue&type=script&lang=js&"
export * from "./PermissionModal.vue?vue&type=script&lang=js&"
import style0 from "./PermissionModal.vue?vue&type=style&index=0&id=5cf845b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf845b4",
  null
  
)

export default component.exports